import React from 'react';
import {Spinner} from '@chakra-ui/react';
import {FullPageCentered} from './layout/FullPage';

export const FullPageLoading = () => (
	<FullPageCentered>
		<Spinner />
	</FullPageCentered>
);
